var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.state.hasRight('55') && !_vm.$store.state.isAdmin())?_c('SpeakerDashboard'):_vm._e(),(_vm.$store.state.hasRight('53'))?_c('FinancialDashboard'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }